import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseHomeLanding } from "./UseHomeLanding";
import { useSnackbar } from "notistack";

export default function LandingItems(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const { deleteLandingItem } = UseHomeLanding();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    if (props.LanID) {
      return navigate("/LandingsManage/addItem", {
        state: {
          search: searchSubGroup,
          backUrl: props.backUrl,
          backName: location.state.backName,
          model: props.model,
          LandingID: props.LandingID,
          LanID: props.LanID,
          rows: props.rows,
          componentFaTitle: location.state.componentFaTitle,
        },
      });
    } else {
      enqueueSnackbar("ابتدا اطلاعات لندینگ را ثبت کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title ? cellValues.row.title : "بدون عنوان"}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/LandingsManage/editItem", {
                    state: {
                      row: cellValues.row,
                      model: props.model,
                      backUrl: props.backUrl,
                      LandingID: props.LandingID,
                      LanID: location.state.LanID,
                      backName: location.state.backName,
                      componentFaTitle: location.state.componentFaTitle,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو محصول"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ pb: 4 }}>
      <Box sx={{ height: "30rem" }}>
        <DataGrid
          className="ltr-grid"
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={props.rows ? props.rows : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={props.rows && props.rows.length ? props.rows.length : 1}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              isLtr: true,
              rowCount:
                props.rows && props.rows.length ? props.rows.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />

        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"آیتم"}
          callback={() => {
            setProgress(true);
            deleteLandingItem(deleteState.id, () => {
              props.callback();
            });
          }}
        ></DeleteRow>
      </Box>
    </Box>
  );
}
